// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--p0Kgm","message":"a10a3f92e9--message--BHjBi","name":"a10a3f92e9--name--ovTfh","tooltip-container":"a10a3f92e9--tooltip-container--_zs7F"};